export default __webpack_public_path__ + "static/media/apps-logo.b22be0ed.svg";